import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Modal, Field, inputCls, Btn, ConfirmDialog, AdminImageUpload } from "./kit";

const SECTIONS = ["WAREHOUSE", "STORAGE", "QUALITY_CHECK", "PACKAGING", "LOADING"];
const EMPTY = { section: "WAREHOUSE", image: "", title: "", description: "", order: 0 };

export default function AdminWarehouse() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [confirm, setConfirm] = useState(null);

  const load = async () => { try { const r = await api.get("/admin/warehouse-media"); setItems(r.data); } catch (e) {} };
  useEffect(() => { load(); }, []);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.image) { toast.error("Upload an image"); return; }
    try { await api.post("/admin/warehouse-media", { ...form, order: parseInt(form.order) || 0 }); toast.success("Added"); setModal(false); setForm(EMPTY); load(); } catch (e) { toast.error("Failed"); }
  };
  const del = async () => { try { await api.delete(`/admin/warehouse-media/${confirm}`); toast.success("Deleted"); setConfirm(null); load(); } catch (e) { toast.error("Failed"); } };

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <div><h1 className="font-display text-2xl font-extrabold text-offwhite">Warehouse Media</h1><p className="mt-1 font-body text-sm text-offwhite/55">Upload real photos per warehouse section.</p></div>
        <Btn onClick={() => { setForm(EMPTY); setModal(true); }} data-testid="add-warehouse-btn"><Plus className="mr-1 inline h-4 w-4" /> Add Photo</Btn>
      </div>
      {SECTIONS.map((sec) => {
        const imgs = items.filter((i) => i.section === sec);
        return (
          <div key={sec} className="mb-6">
            <h3 className="mb-3 font-mono text-xs font-semibold uppercase tracking-wider text-amber-soft">{sec.replace("_", " ")}</h3>
            {imgs.length === 0 ? <div className="rounded-lg border border-dashed border-offwhite/15 py-6 text-center font-body text-xs text-offwhite/35">No photos in this section.</div> : (
              <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
                {imgs.map((it) => (
                  <div key={it.id} className="group relative overflow-hidden rounded-lg border border-offwhite/10">
                    <img src={it.image} alt={it.title} className="aspect-[4/3] w-full object-cover" />
                    <button onClick={() => setConfirm(it.id)} className="absolute right-2 top-2 rounded-full bg-rose-600 p-1.5 text-white opacity-0 transition-opacity group-hover:opacity-100"><Trash2 className="h-3.5 w-3.5" /></button>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
      <Modal open={modal} onClose={() => setModal(false)} title="Add Warehouse Photo">
        <div className="space-y-4">
          <AdminImageUpload value={form.image} onChange={(v) => set("image", v)} testId="warehouse-image-upload" />
          <Field label="Section"><select className={inputCls} value={form.section} onChange={(e) => set("section", e.target.value)}>{SECTIONS.map((s) => <option key={s} value={s}>{s.replace("_", " ")}</option>)}</select></Field>
          <Field label="Title"><input className={inputCls} value={form.title} onChange={(e) => set("title", e.target.value)} /></Field>
          <Field label="Description"><textarea rows={2} className={inputCls} value={form.description} onChange={(e) => set("description", e.target.value)} /></Field>
          <div className="flex justify-end gap-3"><Btn variant="ghost" onClick={() => setModal(false)}>Cancel</Btn><Btn onClick={save} data-testid="save-warehouse-btn">Save</Btn></div>
        </div>
      </Modal>
      <ConfirmDialog open={!!confirm} onClose={() => setConfirm(null)} onConfirm={del} message="Delete this photo?" />
    </div>
  );
}
